var render, staticRenderFns
import script from "./LotViewBiddingTimed.vue?vue&type=script&lang=js&"
export * from "./LotViewBiddingTimed.vue?vue&type=script&lang=js&"
import style0 from "./LotViewBiddingTimed.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LotViewBiddingTimed.vue?vue&type=style&index=1&id=536f1bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536f1bab",
  null
  
)

export default component.exports